var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "users" } },
    [
      _vm.showUpgrade
        ? _c("PlanUpgradeConfirm", {
            attrs: { type: "supsis" },
            on: {
              close: function ($event) {
                _vm.showUpgrade = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showUpgradeNeeded
        ? _c("UpgradeNeeded", {
            on: {
              close: function ($event) {
                _vm.showUpgradeNeeded = false
              },
              upgrade: _vm.upgradePlan,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeUserCount >= _vm.features.maxAgentCount
        ? _c(
            "a-alert",
            {
              staticClass: "mb-2",
              attrs: {
                message: _vm.$t("message.planInfoHeader"),
                type: "info",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  attrs: { slot: "description" },
                  slot: "description",
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c("a-icon", { attrs: { type: "info-circle" } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "p-1 text-info ml-1" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t("message.planInformation", {
                                selectedPlan: _vm.getCurrentPlanName(),
                                detailMaxAgentCount: _vm.features.maxAgentCount,
                                freeAgent: _vm.features.freeAgentCount,
                              })
                            ) +
                            "\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "p-1 text-info mt-1" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.creditAvailable")) +
                        "\n                "
                    ),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.features.maxAgentCount - _vm.activeUserCount)
                      ),
                    ]),
                    _vm._v(
                      " .\n                " +
                        _vm._s(_vm.$t("message.upDownGradePlan")) +
                        "\n                "
                    ),
                    _c(
                      "button",
                      {
                        staticStyle: {
                          "border-radius": "15%",
                          border: "none",
                          "background-color": "lightskyblue",
                          "font-size": "larger",
                        },
                        attrs: { id: "btn-change-plan" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/billing")
                          },
                        },
                      },
                      [_c("b", [_vm._v(_vm._s(_vm.$t("message.click")))])]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("supsis-table", {
        staticClass: "users-supsis-table",
        attrs: {
          columns: _vm.cols(),
          rows: _vm.getFilteredRows(),
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("a-input-search", {
                          staticClass: "search-input",
                          attrs: {
                            value: _vm.searchText,
                            placeholder: _vm.$t("message.startFilter"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.searchTextHandle($event)
                            },
                            search: _vm.onSearch,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["user.create"].tr.name
                    )
                      ? _c(
                          "SupsisButton",
                          {
                            attrs: { ghost: "" },
                            on: { click: _vm.openCreateModal },
                          },
                          [
                            _c("md-icon", [_vm._v("add")]),
                            _vm._v(" Create User\n                "),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "user-form",
                title: _vm.editMode
                  ? _vm.$t("message.updateUserForm")
                  : _vm.$t("message.newUserForm"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _vm.$validator.errors.items.length && _vm.submitClicked
                ? _c(
                    "a-alert",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        message: _vm.$t("message.error"),
                        showIcon: "",
                        type: "error",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "description" }, slot: "description" },
                        _vm._l(_vm.$validator.errors.items, function (err) {
                          return _c("div", [
                            _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(err.msg) +
                                  "\n                    "
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form",
                {
                  staticClass: "d-flex flex-column justify-content-center",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSave.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "md-field",
                                    {
                                      class: {
                                        "md-invalid":
                                          _vm.errors.first(
                                            _vm.$t("message.username")
                                          ) != null,
                                      },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.username"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'",
                                          },
                                        ],
                                        attrs: {
                                          name: _vm.$t("message.username"),
                                          type: "text",
                                          placeholder:
                                            _vm.$t("message.username"),
                                          autocomplete: "off",
                                        },
                                        model: {
                                          value: _vm.user.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.user, "name", $$v)
                                          },
                                          expression: "user.name",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "md-error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              _vm.$t("message.username")
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "md-field",
                                    {
                                      class: {
                                        "md-invalid":
                                          _vm.errors.first(
                                            _vm.$t("message.email")
                                          ) != null,
                                      },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("message.email"))),
                                      ]),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              regex:
                                                /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,}(\.\w{2,4})?$/,
                                            },
                                            expression:
                                              "{\n                                        required: true,\n                                        regex: /^[\\w-\\.+]+@([\\w-]+\\.)+[\\w-]{2,}(\\.\\w{2,4})?$/,\n                                    }",
                                          },
                                        ],
                                        attrs: {
                                          name: _vm.$t("message.email"),
                                          autocomplete: "off",
                                          trim: "",
                                          type: "email",
                                        },
                                        model: {
                                          value: _vm.user.email,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.user, "email", $$v)
                                          },
                                          expression: "user.email",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "md-error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              _vm.$t("message.email")
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.shouldShowContent && _vm.editMode
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c("md-field", [
                                        _c("label", [_vm._v("Şifre Güncelle")]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "contents",
                                            },
                                          },
                                          [
                                            _c("md-input", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "message.username"
                                                ),
                                                type: "password",
                                                placeholder: "Şifre Güncelle",
                                                autocomplete: "off",
                                              },
                                              model: {
                                                value: _vm.user.password,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.user,
                                                    "password",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.password",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.editMode
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          class: {
                                            "md-invalid":
                                              _vm.errors.first(
                                                _vm.$t("message.password")
                                              ) != null,
                                          },
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.password", {
                                                  num: "6",
                                                })
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.editMode
                                                  ? "min:6"
                                                  : "required|min:6",
                                                expression:
                                                  "editMode ? 'min:6' : 'required|min:6'",
                                              },
                                            ],
                                            ref: _vm.$t("message.password"),
                                            attrs: {
                                              name: _vm.$t("message.password"),
                                              placeholder: _vm.$t(
                                                "message.passwordAtLeast",
                                                {
                                                  num: "6",
                                                }
                                              ),
                                              autocomplete: "off",
                                              trim: "",
                                              type: "password",
                                            },
                                            model: {
                                              value: _vm.user.password,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.user,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "user.password",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "md-error" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    _vm.$t("message.password")
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.editMode
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          class: {
                                            "md-invalid":
                                              _vm.errors.first(
                                                _vm.$t("message.passwordRepeat")
                                              ) != null,
                                          },
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.passwordRepeat")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: _vm.editMode
                                                  ? "confirmed:" +
                                                    _vm.$t("message.password") +
                                                    "|min:6"
                                                  : "required|confirmed:" +
                                                    _vm.$t("message.password") +
                                                    "|min:6",
                                                expression:
                                                  "\n                                        editMode\n                                            ? 'confirmed:' + $t('message.password') + '|min:6'\n                                            : 'required|confirmed:' + $t('message.password') + '|min:6'\n                                    ",
                                              },
                                            ],
                                            attrs: {
                                              name: _vm.$t(
                                                "message.passwordRepeat"
                                              ),
                                              autocomplete: "off",
                                              type: "password",
                                            },
                                            model: {
                                              value: _vm.passwordConfirmation,
                                              callback: function ($$v) {
                                                _vm.passwordConfirmation = $$v
                                              },
                                              expression:
                                                "passwordConfirmation",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "md-error" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    _vm.$t(
                                                      "message.passwordRepeat"
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkPermission(
                                _vm.PERMISSION_TYPES["role.get"].tr.name
                              )
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "role-input-group",
                                            label: _vm.$t("message.role"),
                                            "label-for": "role-input",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "default-value": _vm.user.role,
                                                "filter-option":
                                                  _vm.filterOption,
                                                name: _vm.$t("message.role"),
                                                placeholder: _vm.$t(
                                                  "message.selectARole"
                                                ),
                                                "option-filter-prop":
                                                  "children",
                                                "show-search": "",
                                              },
                                              model: {
                                                value: _vm.user.role,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.user,
                                                    "role",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.role",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: undefined } },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.selectARole"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.roles.data,
                                                function (r) {
                                                  return _c(
                                                    "a-select-option",
                                                    {
                                                      key: r._id,
                                                      attrs: { value: r._id },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(r.name) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "lang-input-group",
                                        label: _vm.$t("message.language"),
                                        "label-for": "lang-input",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'",
                                            },
                                          ],
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            "default-value": _vm.user.lang,
                                            "filter-option": _vm.filterOption,
                                            "option-filter-prop": "children",
                                            "show-search": "",
                                            name: _vm.$t("message.language"),
                                          },
                                          model: {
                                            value: _vm.user.lang,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.user, "lang", $$v)
                                            },
                                            expression: "user.lang",
                                          },
                                        },
                                        _vm._l(_vm.languages, function (r, ii) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: ii,
                                              attrs: { value: r.code },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(r.label) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "md-field",
                                    {
                                      class: {
                                        "md-invalid":
                                          _vm.errors.first(
                                            _vm.$t(
                                              "message.autoChatAssignLimit"
                                            )
                                          ) != null,
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { name: "auto-assign" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.autoChatAssignLimit"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        staticClass: "mt-2",
                                        attrs: {
                                          id: "auto-assign-limit-input",
                                          name: _vm.$t(
                                            "message.autoChatAssignLimit"
                                          ),
                                          autocomplete: "off",
                                          min: "-1",
                                          type: "number",
                                        },
                                        model: {
                                          value: _vm.user.autoAssignLimit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.user,
                                              "autoAssignLimit",
                                              $$v
                                            )
                                          },
                                          expression: "user.autoAssignLimit",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "md-error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first(
                                              _vm.$t(
                                                "message.autoChatAssignLimit"
                                              )
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      "-" +
                                        _vm._s(_vm.$t("message.chatAssignInfo"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-col", { attrs: { md: "12" } }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "typo__label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("message.relatedDepartments")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("multiselect", {
                                      attrs: {
                                        multiple: true,
                                        options: _vm.getSubjectOptions(),
                                        placeholder: _vm.$t(
                                          "message.relatedDepartments"
                                        ),
                                        label: "text",
                                        "track-by": "value",
                                      },
                                      model: {
                                        value: _vm.selectedDepartments,
                                        callback: function ($$v) {
                                          _vm.selectedDepartments = $$v
                                        },
                                        expression: "selectedDepartments",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { md: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-start align-items-center",
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("message.status"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "md-switch",
                                      {
                                        staticClass: "md-primary ml-3",
                                        attrs: {
                                          disabled:
                                            _vm.loggedUser._id === _vm.user._id,
                                        },
                                        model: {
                                          value: _vm.switchButton,
                                          callback: function ($$v) {
                                            _vm.switchButton = $$v
                                          },
                                          expression: "switchButton",
                                        },
                                      },
                                      [
                                        _vm.user.enable
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.active"))
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.passive")
                                                )
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        disabled: _vm.loading,
                                        type: "submit",
                                        variant: "primary",
                                      },
                                    },
                                    [
                                      !_vm.loading
                                        ? [
                                            !_vm.editMode
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.save")
                                                    )
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.update")
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        : [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "spinner",
                                                spin: "",
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    { on: { click: _vm.hideModal } },
                                    [
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("message.cancel"))
                                        ),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }